import { AxiosError } from "axios";
import normalizeBaseResponse from "../responseHandler";
import { BaseResponse } from "../../db/response"; // adjust the path as needed

const errorHandler = (error: unknown): BaseResponse => {
  const axiosError = error as AxiosError;

  // If there's a response with data, try to normalize it
  if (axiosError?.response?.data) {
    const responseData = axiosError.response.data;
    const httpStatus = axiosError.response.status;
    
    // Handle plain string error responses (e.g., "Invalid credentials provided.")
    if (typeof responseData === 'string') {
      return {
        status: "FAILURE",
        statusinfo: {
          code: String(httpStatus) || "HTTP_ERROR",
          message: responseData || "An error occurred",
        },
      };
    }
    
    const normalized = normalizeBaseResponse(responseData);
    
    // Check if the HTTP status code indicates an error (400-599)
    // If so, ensure the status is FAILURE even if normalizeBaseResponse returned SUCCESS
    if (httpStatus >= 400 && httpStatus < 600) {
      // If normalized response is SUCCESS but HTTP status is error, override it
      if (normalized.status === "SUCCESS") {
        // Extract error message from response
        const errorData = responseData as any;
        let errorMessage = "An error occurred";
        
        // Check for simple error format: {"error": "Unauthorized"}
        if (errorData?.error && typeof errorData.error === 'string') {
          errorMessage = errorData.error;
        } else if (errorData?.errors && Array.isArray(errorData.errors) && errorData.errors.length > 0) {
          errorMessage = errorData.errors[0].message || errorMessage;
        } else if (errorData?.errors?.message) {
          errorMessage = errorData.errors.message;
        } else if (errorData?.message) {
          errorMessage = errorData.message;
        } else if (errorData?.statusinfo?.message) {
          errorMessage = errorData.statusinfo.message;
        } else if (errorData?.status?.statusinfo?.message) {
          errorMessage = errorData.status.statusinfo.message;
        }
        
        return {
          status: "FAILURE",
          statusinfo: {
            code: String(httpStatus) || "HTTP_ERROR",
            message: errorMessage,
          },
        };
      }
    }
    
    return normalized;
  }

  // Network error or no response
  return {
    status: "FAILURE",
    statusinfo: {
      code: "NETWORK_ERROR",
      message: "Unable to connect to the server. Please check your internet connection.",
    },
  };
};

export default errorHandler;
